import { Component } from '@angular/core';

@Component({
    selector: 'app-placeholder-card',
    standalone: true,
    templateUrl: './placeholder-card.component.html',
    styleUrl: './placeholder-card.component.scss',
})
export class PlaceholderCardComponent {}
